import { useTranslation } from "react-i18next";
import PaymentDrawer from "./PaymentDrawer";
import React, { useRef, useState } from "react";
import { addCart, updateTableSession } from "../../Services/CartApi";
import { toast } from "react-toastify";
import { updateTableStatus } from "../../Services/TablesApi";
import {
  convertCartsToCartItems,
  formadate,
  formatDate,
  getImageUrl,
  ImpressionTicket,
  buildReceiptCart,
} from "../../Helpers/Helpers";
import iconv from "iconv-lite"; // npm i iconv-lite
import { PrintAction } from "../../Shared/Hardware/PrintActions";
import { testPrinterConnection } from "../../Shared/Hardware/testprint";
import { updateCashJournal } from "../../Services/JournalApi";
import { useUser } from "../../Auth/useUser";
import Swal from "sweetalert2";
import { getProductByBarCode } from "../../Services/MenuApi";
import { Form, Spinner } from "react-bootstrap";

import axios from "axios";
import KeyboardComponent from "./keyboards/virtualKeypad";
import FocusedCartItem from "./FocusedCartItem";
import OrderDetailsModal from "../OrderDetails";

const CaisseCart = ({
  parametrages,
  cartItems,
  setCartItems,
  orderItems,
  payments,
  previousPayments,
  onRemoveFromCart,
  onUpdateQuantity,
  cartTotal,
  total,
  onClearCart,
  organisation,
  selectedTable,
  onTableSelect,
  refresh,
  setRefresh,
  occupiedTableData,
  lockCaisse,
  onAddToCart, // Add this prop to handle adding products to cart
  selectedClient, // New prop for selected client
  onClientSelect, // New prop for client selection
  resetClientToDefault,
  // Focused single-item editor + Calculator — state/logic now owned by
  // Caisse.jsx so the same Calculator can eventually be reused by sibling
  // components (product/client search). CaisseCart just renders the slot
  // and triggers open/close/edit via these callbacks.
  focusedItemId,
  focusedItem,
  editingField,
  fieldBuffer,
  openFocusedItem,
  closeFocusedItem,
  startEditingField,
  stopEditingField,
  calculatorSlot,
}) => {
  const { t } = useTranslation();
  const user = useUser();
  const [infoUser] = useState(user.result);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  // On-screen ticket fallback when "Impression ticket" is off in parametrage caisse
  const [receiptCart, setReceiptCart] = useState(null);
  const [receiptModalOpen, setReceiptModalOpen] = useState(false);
  const activeJournal = JSON.parse(localStorage.getItem("activeJournal"));
  const storedCaisse = JSON.parse(localStorage.getItem("caisse_data"));
  const storedCaisseID = storedCaisse ? storedCaisse.id : null;
  // Barcode state
  const [barcodeInput, setBarcodeInput] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const barcodeInputRef = React.useRef(null);
  // Long-press a cart row to open the parent-owned focused item editor.
  const longPressTimerRef = useRef(null);
  const longPressFiredRef = useRef(false);
  // Load clients on component mount or when organisation changes

  // Set current client when default client is loaded or selected client changes

  let items = [...cartItems, ...orderItems].map((item) =>
    item.originalCartData ? item.originalCartData : item,
  );
  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };
  const [tabIndex, setTabIndex] = useState(0);
  // Selection state
  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleRowPressStart = (item) => {
    if (selectionMode) return;
    longPressFiredRef.current = false;
    longPressTimerRef.current = setTimeout(() => {
      longPressFiredRef.current = true;
      openFocusedItem(item.id);
    }, 450);
  };

  const handleRowPressEnd = () => {
    if (longPressTimerRef.current) {
      clearTimeout(longPressTimerRef.current);
      longPressTimerRef.current = null;
    }
  };

  // Handle item selection/deselection
  const handleItemSelection = (item) => {
    if (!selectionMode) return;

    setSelectedItems((prev) => {
      const isSelected = prev.some((selected) => selected._id === item.id);

      if (isSelected) {
        // Deselect the item
        return prev.filter((selected) => selected._id !== item.id);
      } else {
        // 1. Calculate the total price of all ingredients
        const ingredientsPrice = (item.ingredients || []).reduce(
          (sum, ing) => sum + (Number(ing.prix) || 0),
          0,
        );

        // 2. Base price is (Product Price + Ingredients Price)
        const unitPriceWithIngredients = item.price + ingredientsPrice;
        const calculatedTotal = unitPriceWithIngredients * item.quantity;

        const newItem = {
          _id: item.id,
          product: item.productInfo,
          ingredients: item.ingredients || [],
          quantity: item.quantity,
          price: item.price,
          remise: item.remise || 0,
          // 3. Update these to include the extra costs
          totalPrice: calculatedTotal,
          netPrice: calculatedTotal - (item.remise || 0),
        };
        return [...prev, newItem];
      }
    });
  };

  // Handle quantity change for selected items
  const handleSelectedQuantityChange = (itemId, newQuantity) => {
    if (!selectionMode) return;

    const actualItem = [...cartItems, ...orderItems].find(
      (item) => item.id === itemId,
    );
    const maxQuantity = actualItem ? actualItem.quantity : 0;
    const limitedQuantity = Math.max(1, Math.min(newQuantity, maxQuantity));

    setSelectedItems((prev) =>
      prev.map((selected) => {
        if (selected._id === itemId) {
          // Re-calculate ingredient sum for this specific item
          const ingredientsPrice = (selected.ingredients || []).reduce(
            (sum, ing) => sum + (Number(ing.prix) || 0),
            0,
          );

          const unitPriceWithIngredients = selected.price + ingredientsPrice;
          const newTotalPrice = unitPriceWithIngredients * limitedQuantity;

          return {
            ...selected,
            quantity: limitedQuantity,
            totalPrice: newTotalPrice,
            netPrice: newTotalPrice - (selected.remise || 0),
          };
        }
        return selected;
      }),
    );
  };
  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };
  const handleQuantityChange = (productId, newQuantity) => {
    onUpdateQuantity(productId, parseInt(newQuantity) || 0);
  };

  const confirmTableOrder = async () => {
    // 1. Demander confirmation à l'utilisateur
    const result = await Swal.fire({
      title: "Confirmer la commande ?",
      text: "Voulez-vous vraiment valider la commande pour cette table ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      confirmButtonText: "Oui, confirmer",
      cancelButtonText: "Annuler",
    });

    // 2. Si l'utilisateur a cliqué sur "Oui"
    if (result.isConfirmed) {
      try {
        // Affichage d'un indicateur de chargement
        Swal.showLoading();
        setIsConfirmed(true);
        const response = await updateTableSession(
          occupiedTableData.session._id,
          { confirmed: true },
        );

        // Vérification de la réponse (Note : j'ai gardé votre condition !== "0")
        if (response.data.success !== "0") {
          await Swal.fire({
            title: "Succès !",
            text: "La commande a été confirmée avec succès.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        } else {
          throw new Error("Erreur serveur");
        }
      } catch (error) {
        // 3. Gestion des erreurs (réseau ou serveur)
        Swal.fire({
          title: "Échec",
          text: "Une erreur est survenue lors de la confirmation.",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    }
  };
  const cancelTableOrder = async () => {
    // 1. Demander confirmation à l'utilisateur
    const result = await Swal.fire({
      title: "Annuler la commande ?",
      text: "Voulez-vous vraiment annuler la commande pour cette table ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#28a745",
      cancelButtonColor: "#dc3545",
      confirmButtonText: "Oui, confirmer",
      cancelButtonText: "Annuler",
    });

    // 2. Si l'utilisateur a cliqué sur "Oui"
    if (result.isConfirmed) {
      try {
        // Affichage d'un indicateur de chargement
        Swal.showLoading();

        const response = await updateTableSession(
          occupiedTableData.session._id,
          { confirmed: false, status: "canceled" },
        );

        // Vérification de la réponse (Note : j'ai gardé votre condition !== "0")
        if (response.data.success !== "0") {
          await Swal.fire({
            title: "Succès !",
            text: "La commande a été confirmée avec succès.",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        } else {
          throw new Error("Erreur serveur");
        }
      } catch (error) {
        // 3. Gestion des erreurs (réseau ou serveur)
        Swal.fire({
          title: "Échec",
          text: "Une erreur est survenue lors de la confirmation.",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    }
  };
  const callImpression = async (dataTicket, type) => {
    const lines = ImpressionTicket(type, {
      ...dataTicket,
    });

    const finalBuffer = (() => {
      const allBytes = [];
      // treat `lines` as string
      const buf = iconv.encode(lines, "ISO-8859-1");
      allBytes.push(...buf);
      return new Uint8Array(allBytes);
    })();
    await PrintAction(finalBuffer, true);
  };

  // Prints the ticket as before, unless "Impression ticket" is turned off in
  // parametrage caisse — then it's shown on screen instead of printed.
  const issueTicket = (dataTicket, type) => {
    if (parametrages?.impressionTicket === false) {
      setReceiptCart(buildReceiptCart(dataTicket, type));
      setReceiptModalOpen(true);
      return;
    }
    callImpression(dataTicket, type);
  };
  const handleAddictionPrint = async () => {
    const data = {
      session: occupiedTableData.session,
      items: convertCartsToCartItems(
        occupiedTableData.carts,
        parametrages?.products_grouping,
      ),
      table: occupiedTableData.table,
      timbre: parametrages?.timbre || 0,
    };
    issueTicket(data, "addition");
  };

  const handleResetCart = async () => {
    const result = await Swal.fire({
      title: "Vider le panier ?",
      text: "Les produits du panier seront supprimés, le client remis par défaut et le total remis à 0.00.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Oui, vider",
      cancelButtonText: "Annuler",
    });

    if (!result.isConfirmed) return;

    onClearCart();
    if (resetClientToDefault) resetClientToDefault();
  };

  const handleValidateCart = async () => {
    if (cartItems.length === 0) {
      toast.warning("Le panier est vide!");
      return;
    }

    if (!selectedTable) {
      toast.warning("Veuillez sélectionner une table!");
      return;
    }

    try {
      console.log("selectedClient", selectedClient);
      // Transform  items for the API
      const cartData = {
        table_id: selectedTable._id || selectedTable.id,
        organisation_id: organisation,
        journal_id: activeJournal._id || activeJournal.id,
        numero: activeJournal.sequence,
        produits: cartItems.map((item) => ({
          product: item.productInfo,
          ingredients: item.ingredients ? item.ingredients : [],
          quantity: item.quantity,
          price: item.price,
          totalPrice: item.totalPrice,
          remise: item.remise,
          netPrice: item.netPrice,
        })),
        prix: cartTotal,
        takeAway: false,
        caissier_id:
          infoUser.role === "caissier" || infoUser.role === "admin"
            ? infoUser.id
            : null,
        serveur_id: infoUser.role === "serveur" ? infoUser.id : null,
        caisse: true,
        caisse_id: storedCaisseID,
        client_id: selectedClient?.id || selectedClient?._id || null,
      };

      // Use the 3-in-1 API
      const response = await addCart(cartData);
      console.log(response);
      console.log("cartItems", cartItems);

      const orderCode = crypto.randomUUID();

      const orderPayload = {
        adresse: "rue des muries",
        client_code: selectedClient?.code_erp || "ERP_CLT_002",
        code: orderCode,

        date: new Date().toISOString().slice(0, 19).replace("T", " "),

        date_prevu_livraison: "",
        depot_code: "nomashop", // ⚠️ must exist

        lignes: cartItems.map((item) => {
          const product = item.productInfo;

          // safer calculations (avoid trusting UI values)
          const quantity = item.quantity || 1;
          const pu_ttc = product.prix_ttc || item.price || 0;
          const pu_ht = product.prix_ht || 0;
          const remise = item.remise || 0;

          const total = pu_ttc * quantity - remise;
          const total_ht = pu_ht * quantity;

          return {
            entetecommercial_code: orderCode,

            // 🔴 CRITICAL FIELD
            produit_code: product.code_erp, // must match Clediss DB

            pu_ttc: pu_ttc,
            pu_ht: pu_ht,

            quantite: quantity,
            remise: remise,

            total: total,
            total_ht: total_ht,

            netAPayer: total,
            netAPayer_ht: total_ht,

            type: "commande",
          };
        }),

        montant_total_ht: cartItems.reduce(
          (sum, item) => sum + (item.productInfo.prix_ht || 0) * item.quantity,
          0,
        ),

        montant_total_ttc: cartItems.reduce(
          (sum, item) =>
            sum + (item.productInfo.prix_ttc || item.price) * item.quantity,
          0,
        ),

        montant_total_tva: 0, // optional unless required

        net_a_payer: cartItems.reduce(
          (sum, item) =>
            sum +
            (item.productInfo.prix_ttc || item.price) * item.quantity -
            (item.remise || 0),
          0,
        ),

        remise: 0,

        societe_code: "utic", // ⚠️ must exist
        soussociete_code: "utic", // ⚠️ must exist

        type: "commande",
        user_code: "nomashop",
      };

      // 2. Send to the Clediss API
      try {
        const cledissResponse = await axios.post(
          "https://api.demo.clediss.online/api/v1/storeCommandeFromWeb",
          orderPayload,
        );
        console.log("Clediss Sync Success:", cledissResponse.data);
      } catch (cledissError) {
        console.error("Failed to sync with Clediss:", cledissError);
        // Optional: toast.error("Sync technique échoué");
      }

      // Example: How to access a value
      console.log(orderPayload.net_a_payer); // Outputs: 392.12
      if (response.data.success !== "0") {
        const result = response.data.data;
        const updatedJournal = {
          ...activeJournal,
          sequence: activeJournal.sequence + 1,
        };

        localStorage.setItem("activeJournal", JSON.stringify(updatedJournal));
        toast.success("Commande créée avec succès!");
        issueTicket({ ...result.cart, session: result.session }, "produits");
        onClearCart();
        setSelectionMode(false);
        lockCaisse();
      } else {
        toast.error("Erreur lors de la création de la commande");
      }
    } catch (error) {
      console.error("Error creating session with cart:", error);
      toast.error(
        "Erreur lors de la création de la commande: " +
          (error.response?.data?.message || error.message),
      );
    }
  };
  const handleClearTable = () => {
    onTableSelect(null);
    setSelectionMode(false);
    // Reset selection when clearing table
    setSelectedItems([]);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingsearch, setloadingsearch] = useState(false);

  const timeoutRef = useRef(null);
  const lastKeyPressTime = useRef(0);
  const handleInputChange = async (inputValue) => {
    setloadingsearch(true);
    setSearchTerm(inputValue);
    const resultArticle = await getProductByBarCode({
      barcode: inputValue,
      organisation,
    });
    if (resultArticle.data.success) {
      onAddToCart({
        id: resultArticle.data.data._id,
        name: resultArticle.data.data.titre?.fr,
        price: resultArticle.data.data.prix_ttc,
        ingredients: [],
        productInfo: resultArticle.data.data,
      });
      // Fetch remises only after item is added to the cart
      setRefresh(!refresh);

      setSearchTerm("");
    } else {
      toast.warning(t("Ce code n'est associé à aucun article"));
      setSearchTerm("");
    }

    // }

    setloadingsearch(false);

    // else if (resultBon.payload) {
    //   setSearchTerm("");

    //   const expireDate = new Date(resultBon.payload.dateEcheance);

    //   const expireDateLocal = new Date(
    //     expireDate.getTime() + expireDate.getTimezoneOffset() * 60000
    //   );
    //   if (expireDateLocal < today) {
    //     ToastWarning("Ce bon de réduction est expiré !");
    //   } else {
    //     dispatch(setReduction(resultBon.payload.amount));
    //     setRefresh(!refresh);
    //   }
    // }
  };
  const handleChange = (cleanedValue) => {
    setSearchTerm(cleanedValue);
    const now = Date.now();
    const timeDiff = now - lastKeyPressTime.current;
    lastKeyPressTime.current = now;
    // Si le temps entre deux entrées est court, c'est probablement un scan
    const isScannerInput = timeDiff < 50;
    //117065alert(isScannerInput)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(
      () => {
        if (cleanedValue !== "" || isScannerInput) {
          handleInputChange(cleanedValue);
        }
      },
      isScannerInput ? 100 : 2000,
    );
  };
  console.log("total", total);
  console.log("carttotal", cartTotal);
  console.log(
    "totaltopay",
    selectedItems.reduce((acc, item) => acc + item.netPrice, 0),
  );
  console.log("totalsession", occupiedTableData?.session?.total_amount);
  const totalToPay =
    selectionMode && selectedItems.length > 0
      ? selectedItems.reduce((acc, item) => acc + item.netPrice, 0) === total
        ? total + parametrages?.timbre
        : selectedItems.reduce((acc, item) => acc + item.netPrice, 0)
      : total + parametrages?.timbre; // This is the original total prop passed to CaisseCart

  // Same pastel-red cue as ClientSelector when the active client owes credit
  const hasClientCredit = Number(selectedClient?.credit) > 0;

  return (
    <div
      className="content-wrapper pt-1 no-min-height"
      style={{
        margin: 0,
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 90px)",
      }}
    >
      <div
        className="container-full"
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden", // Prevents component overflowing outside the bounding height
        }}
      >
        {/* Barcode Input Section */}
        {/* <div
          className="client-selection-section"
          style={{
            padding: "10px",
            backgroundColor: "#f8f9fa",
            borderBottom: "1px solid #dee2e6",
            flexShrink: 0,
          }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <i className="fa fa-user mr-2" style={{ color: "#6c757d" }}></i>
              <span style={{ fontWeight: "bold", marginRight: "10px" }}>
                Client:
              </span>
              {loadingClients ? (
                <Spinner animation="border" size="sm" />
              ) : currentClient ? (
                <div className="d-flex align-items-center">
                  <span
                    className="badge badge-info"
                    style={{ marginRight: "8px" }}
                  >
                    {currentClient.code}
                  </span>
                  <span>{currentClient.name}</span>
                  {currentClient.isDefault && (
                    <span
                      className="badge badge-warning ml-2"
                      style={{ fontSize: "10px" }}
                    >
                      Par défaut
                    </span>
                  )}
                  <button
                    className="btn btn-sm btn-outline-secondary ml-2"
                    onClick={() => setShowClientDropdown(!showClientDropdown)}
                    style={{ padding: "2px 8px" }}
                  >
                    <i className="fa fa-exchange-alt"></i>
                  </button>
                </div>
              ) : (
                <div>
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => setShowClientDropdown(!showClientDropdown)}
                  >
                    <i className="fa fa-plus mr-1"></i>
                    Sélectionner un client
                  </button>
                </div>
              )}
            </div>

            <div className="barcode-input" style={{ width: "300px" }}>
              <div className="input-group input-group-sm">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <i className="fa fa-barcode"></i>
                  </span>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Scanner un code-barres..."
                  value={searchTerm}
                  onChange={(e) => handleChange(e.target.value)}
                  ref={barcodeInputRef}
                  autoFocus
                />
                {loadingsearch && (
                  <div className="input-group-append">
                    <span className="input-group-text">
                      <Spinner animation="border" size="sm" />
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {showClientDropdown && (
            <div
              className="client-dropdown"
              style={{
                position: "absolute",
                top: "70px",
                right: "20px",
                zIndex: 1000,
                backgroundColor: "white",
                border: "1px solid #dee2e6",
                borderRadius: "4px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                maxHeight: "300px",
                overflowY: "auto",
                minWidth: "250px",
              }}
            >
              <div className="p-2">
                <input
                  type="text"
                  className="form-control form-control-sm mb-2"
                  placeholder="Rechercher un client..."
                  onChange={(e) => {
                    const searchTerm = e.target.value.toLowerCase();
                    const filtered = clients.filter(
                      (c) =>
                        c.name.toLowerCase().includes(searchTerm) ||
                        c.code.toLowerCase().includes(searchTerm),
                    );
                    // You would need to add state for filtered clients
                  }}
                />
                {clients.map((client) => (
                  <div
                    key={client.id || client._id}
                    className="client-item p-2"
                    style={{
                      cursor: "pointer",
                      borderBottom: "1px solid #f0f0f0",
                      backgroundColor:
                        currentClient?.id === (client.id || client._id)
                          ? "#e3f2fd"
                          : "transparent",
                    }}
                    onClick={() => handleClientSelect(client)}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f8f9fa")
                    }
                    onMouseLeave={(e) => {
                      if (currentClient?.id !== (client.id || client._id)) {
                        e.currentTarget.style.backgroundColor = "transparent";
                      }
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <strong>{client.code}</strong> - {client.name}
                      </div>
                      {client.isDefault && (
                        <span
                          className="badge badge-warning"
                          style={{ fontSize: "10px" }}
                        >
                          Defaut
                        </span>
                      )}
                    </div>
                  </div>
                ))}
                {clients.length === 0 && (
                  <div className="text-center text-muted p-2">
                    Aucun client trouvé
                  </div>
                )}
              </div>
            </div>
          )}
        </div> */}
        {/* Main content */}
        <section
          className="content"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            margin: 0,
            padding: "0px 5px 0px 3px",
          }}
        >
          <div
            className="row"
            style={{ flex: 1, display: "flex", flexDirection: "column" }}
          >
            <div
              className="col-12 col-lg-12"
              style={{ flex: 1, display: "flex", flexDirection: "column" }}
            >
              <div
                className="box mb-0"
                style={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: hasClientCredit ? "#fdecea" : undefined,
                }}
              >
                {/* Header - Fixed */}
                <div
                  className="box-header bg-primary"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexShrink: 0,
                    padding: "10px 15px",
                  }}
                >
                  <h4 className="box-title">
                    {selectedTable && (
                      <div
                        className="table-display-header"
                        style={{
                          color: "white",
                          fontWeight: "bold",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          backgroundColor: "rgba(255,255,255,0.2)",
                          padding: "5px 10px",
                          borderRadius: "4px",
                        }}
                      >
                        <span>
                          {selectedTable.default
                            ? "Comptoir"
                            : "Table: " + selectedTable.table_number}
                        </span>
                        {!selectedTable.default && (
                          <button
                            className="btn btn-xs btn-outline-light"
                            onClick={handleClearTable}
                            style={{
                              padding: "0px 5px",
                              fontSize: "12px",
                              marginLeft: "5px",
                            }}
                            title="Changer de table"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                      </div>
                    )}
                  </h4>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    {/* Total Display */}
                    <div
                      className="cart-total-header"
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        fontSize: "18px",
                      }}
                    >
                      Total: {totalToPay.toFixed(3)}
                    </div>

                    {cartItems.length > 0 && (
                      <button
                        className="btn btn-sm btn-outline-light shadow-sm"
                        onClick={handleResetCart}
                        title="Réinitialiser le panier"
                        style={{
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <i className="fas fa-times mr-1"></i>
                      </button>
                    )}
                  </div>
                </div>

                {/* Rest of the Cart component remains the same */}
                <div
                  className="box-body"
                  style={{
                    height: "400px", // Set a fixed height or use calc(100vh - 500px)
                    overflowY: "auto",
                    padding: "10px",
                    flexShrink: 1, // Allows the list to shrink if the window is small
                    backgroundColor: hasClientCredit ? "#fdecea" : undefined,
                  }}
                >
                  {focusedItemId ? (
                    <FocusedCartItem
                      key={focusedItemId}
                      item={focusedItem}
                      editingField={editingField}
                      fieldBuffer={fieldBuffer}
                      onStartEditField={startEditingField}
                      onStopEditField={stopEditingField}
                      onBack={closeFocusedItem}
                      onRemove={() => {
                        onRemoveFromCart(focusedItemId);
                        closeFocusedItem();
                      }}
                    />
                  ) : (
                  <div className="table-responsive">
                    <table className="table product-overview">
                      <tbody>
                        {cartItems.length === 0 && orderItems.length === 0 ? (
                          <tr>
                            <td
                              colSpan="6"
                              className="text-center"
                              style={{ padding: "40px" }}
                            >
                              <div
                                style={{ color: "#6c757d", fontSize: "16px" }}
                              >
                                <i
                                  className="fa fa-shopping-cart fa-2x mb-3"
                                  style={{ opacity: 0.5 }}
                                ></i>
                                <p>Votre panier est vide</p>
                                <small className="text-muted">
                                  Ajoutez des produits en scannant leur
                                  code-barres
                                </small>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          [...cartItems, ...orderItems].map((item) => {
                            const isSelected = selectedItems.some(
                              (selected) => selected._id === item.id,
                            );
                            return (
                              <tr
                                key={item.id}
                                onClick={() => {
                                  // Swallow the click that follows a long-press
                                  if (longPressFiredRef.current) {
                                    longPressFiredRef.current = false;
                                    return;
                                  }
                                  if (selectionMode) {
                                    handleItemSelection(item);
                                  }
                                }}
                                onMouseDown={() => handleRowPressStart(item)}
                                onMouseUp={handleRowPressEnd}
                                onMouseLeave={handleRowPressEnd}
                                onTouchStart={() => handleRowPressStart(item)}
                                onTouchEnd={handleRowPressEnd}
                                onTouchMove={handleRowPressEnd}
                                style={{
                                  cursor: selectionMode ? "pointer" : "default",
                                  backgroundColor: isSelected
                                    ? "#fff3e0"
                                    : "transparent",
                                  transition: "background-color 0.2s ease",
                                }}
                              >
                                {/* Keep all existing td elements but modify the quantity and price cells */}
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    padding: 0,
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 50,
                                      height: 50,
                                      borderRadius: "50%",
                                      overflow: "hidden",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      backgroundColor: "#f0f0f0",
                                    }}
                                    onClick={() =>
                                      console.log("cartItems", [...cartItems])
                                    }
                                  >
                                    <img
                                      src={getImageUrl(item.productInfo.image)}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src =
                                          "images/product/no-image.png";
                                      }}
                                      alt={item.productInfo.name}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                </td>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    padding: 0,
                                  }}
                                >
                                  <h6 className="m-0">
                                    {item.productInfo.titre.fr}
                                  </h6>
                                  <p className="text-muted">
                                    {item.productInfo.unite !== "pcs"
                                      ? item.price +
                                        " - " +
                                        item.productInfo.prix_quantite +
                                        item.productInfo.unite
                                      : item.price}
                                  </p>
                                </td>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    padding: 0,
                                  }}
                                >
                                  <h6 className="m-0">
                                    {item.remise > 0 ? item.remise + "%" : ""}
                                  </h6>
                                </td>
                                <td
                                  style={{
                                    verticalAlign: "middle",
                                    padding: 0,
                                  }}
                                >
                                  {selectionMode && isSelected ? (
                                    <div
                                      className="input-group input-group-sm"
                                      style={{ width: "100px" }}
                                    >
                                      <div className="input-group-prepend">
                                        <button
                                          className="btn btn-primary"
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            // CHANGE: Use s._id to find the item
                                            const selectedItem =
                                              selectedItems.find(
                                                (s) => s._id === item.id,
                                              );
                                            const newQuantity = Math.max(
                                              1,
                                              (selectedItem?.quantity || 1) - 1,
                                            );
                                            handleSelectedQuantityChange(
                                              item.id,
                                              newQuantity,
                                            );
                                          }}
                                          // CHANGE: Use s._id and .quantity
                                          disabled={
                                            (selectedItems.find(
                                              (s) => s._id === item.id,
                                            )?.quantity || 1) <= 1
                                          }
                                        >
                                          <i className="ti-minus"></i>
                                        </button>
                                      </div>
                                      <input
                                        type="text"
                                        className="form-control text-center mt-0"
                                        // CHANGE: Already correct in your file, uses .quantity
                                        value={
                                          selectedItems.find(
                                            (s) => s._id === item.id,
                                          )?.quantity || item.quantity
                                        }
                                        min="1"
                                        max={item.quantity}
                                        onChange={(e) => {
                                          e.stopPropagation();
                                          const value =
                                            parseInt(e.target.value) || 1;
                                          handleSelectedQuantityChange(
                                            item.id,
                                            value,
                                          );
                                        }}
                                        style={{
                                          WebkitAppearance: "none",
                                          MozAppearance: "textfield",
                                        }}
                                      />
                                      <div className="input-group-append">
                                        <button
                                          className="btn btn-success"
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            // CHANGE: Use s._id to find the item
                                            const selectedItem =
                                              selectedItems.find(
                                                (s) => s._id === item.id,
                                              );
                                            const newQuantity = Math.min(
                                              item.quantity,
                                              (selectedItem?.quantity || 1) + 1,
                                            );
                                            handleSelectedQuantityChange(
                                              item.id,
                                              newQuantity,
                                            );
                                          }}
                                          // CHANGE: Use s._id and .quantity
                                          disabled={
                                            (selectedItems.find(
                                              (s) => s._id === item.id,
                                            )?.quantity || 1) >= item.quantity
                                          }
                                        >
                                          <i className="ti-plus"></i>
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <div
                                      className="input-group input-group-sm"
                                      style={{ width: "100px" }}
                                    >
                                      {item.productInfo?.unite &&
                                      item.productInfo.unite !== "pcs" ? (
                                        // WEIGHT INPUT — for kg, g, l, etc.
                                        <>
                                          <input
                                            type="number"
                                            readOnly
                                            className="form-control text-center mt-0"
                                            value={item.quantity}
                                            min="0"
                                            step={
                                              item.productInfo.prix_quantite ||
                                              0.1
                                            }
                                            disabled={selectionMode}
                                            style={{
                                              WebkitAppearance: "none",
                                              MozAppearance: "textfield",
                                            }}
                                          />
                                          <div className="input-group-append">
                                            <span
                                              className="input-group-text"
                                              style={{
                                                fontSize: "10px",
                                                padding: "0 4px",
                                              }}
                                            >
                                              {item.productInfo.unite}
                                            </span>
                                          </div>
                                        </>
                                      ) : (
                                        // NORMAL INTEGER INPUT — for pcs
                                        <>
                                          <div className="input-group-prepend">
                                            <button
                                              className="btn btn-primary"
                                              type="button"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleQuantityChange(
                                                  item.id,
                                                  item.quantity - 1,
                                                );
                                              }}
                                              disabled={
                                                item.quantity <= 1 ||
                                                selectionMode
                                              }
                                            >
                                              <i className="ti-minus"></i>
                                            </button>
                                          </div>
                                          <input
                                            type="text"
                                            readOnly
                                            className="form-control text-center mt-0"
                                            value={item.quantity}
                                            min="1"
                                            disabled={selectionMode}
                                            style={{
                                              WebkitAppearance: "none",
                                              MozAppearance: "textfield",
                                            }}
                                          />
                                          <div className="input-group-append">
                                            <button
                                              className="btn btn-success"
                                              type="button"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleQuantityChange(
                                                  item.id,
                                                  item.quantity + 1,
                                                );
                                              }}
                                              disabled={selectionMode}
                                            >
                                              <i className="ti-plus"></i>
                                            </button>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  )}
                                </td>
                                <td
                                  width="100"
                                  align="center"
                                  className="font-weight-900"
                                  style={{
                                    verticalAlign: "middle",
                                    padding: 0,
                                  }}
                                >
                                  {selectionMode && isSelected
                                    ? (() => {
                                        // 1. Find the selected item to get its specific quantity
                                        const selectedItem = selectedItems.find(
                                          (s) => s._id === item.id,
                                        );
                                        const currentQty =
                                          selectedItem?.quantity ||
                                          item.quantity;

                                        // 2. Calculate the sum of ingredient prices
                                        const ingredientsTotal = (
                                          item.ingredients || []
                                        ).reduce(
                                          (sum, ing) =>
                                            sum + (Number(ing.prix) || 0),
                                          0,
                                        );

                                        // 3. (Base Price + Ingredients Price) * Quantity
                                        return (
                                          (item.price + ingredientsTotal) *
                                          currentQty
                                        ).toFixed(3);
                                      })()
                                    : item.netPrice?.toFixed(3)}
                                </td>
                                <td
                                  align="center"
                                  style={{
                                    verticalAlign: "middle",
                                    padding: 0,
                                  }}
                                >
                                  <button
                                    className="btn btn-circle btn-xs danger"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onRemoveFromCart(item.id);
                                    }}
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    disabled={selectionMode}
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                        )}
                        {/* Payment Details Section */}
                        {payments?.length > 0 && (
                          <>
                            {/* Separator */}
                            <tr>
                              <td
                                colSpan="5"
                                style={{ padding: "15px 0 5px 0" }}
                              >
                                <div
                                  style={{
                                    borderTop: "2px solid #dee2e6",
                                    textAlign: "center",
                                    position: "relative",
                                  }}
                                >
                                  <span
                                    style={{
                                      background: "#f8f9fa",
                                      padding: "0 10px",
                                      position: "absolute",
                                      top: "-10px",
                                      left: "50%",
                                      transform: "translateX(-50%)",
                                      color: "#6c757d",
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                    }}
                                  >
                                    RÈGLEMENTS
                                  </span>
                                </div>
                              </td>
                            </tr>

                            {/* Payment Items */}
                            {payments.map((payment, index) => {
                              const amount = Number(payment.amount || 0);
                              const rendu = Number(payment.rendu || 0);

                              return (
                                <React.Fragment key={payment._id || index}>
                                  {/* Payment Row */}
                                  <tr style={{ backgroundColor: "#f8f9fa" }}>
                                    <td
                                      colSpan={4}
                                      style={{
                                        verticalAlign: "middle",
                                        padding: "8px 0",
                                      }}
                                    >
                                      <h6
                                        className="m-0"
                                        style={{ color: "#28a745" }}
                                      >
                                        {payment.payment_method === "cash"
                                          ? "Espèces"
                                          : payment.payment_method ===
                                              "creditcard"
                                            ? "Carte bancaire"
                                            : payment.payment_method ===
                                                "cheque"
                                              ? "Chéque"
                                              : "Ticket cadeau"}
                                      </h6>
                                      <p
                                        className="text-muted"
                                        style={{ fontSize: "12px" }}
                                      >
                                        {formadate(
                                          payment.createdAt || payment.date,
                                        )}
                                      </p>
                                    </td>

                                    <td
                                      width="100"
                                      align="center"
                                      style={{
                                        verticalAlign: "middle",
                                        padding: "8px 0",
                                        color: "#28a745",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      +{amount.toFixed(3)}
                                    </td>
                                  </tr>

                                  {/* Rendu (if any) */}
                                  {rendu > 0 && (
                                    <tr style={{ backgroundColor: "#f8f9fa" }}>
                                      <td
                                        colSpan={4}
                                        style={{
                                          verticalAlign: "middle",
                                          padding: "8px 0",
                                        }}
                                      >
                                        <div style={{ textAlign: "left" }}>
                                          <span
                                            style={{
                                              fontSize: "12px",
                                              color: "#6c757d",
                                            }}
                                          >
                                            Rendu
                                          </span>
                                        </div>
                                      </td>

                                      <td
                                        width="100"
                                        align="center"
                                        style={{
                                          verticalAlign: "middle",
                                          padding: "8px 0",
                                          color: "#dc3545",
                                          fontSize: "16px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        -{rendu.toFixed(3)}
                                      </td>
                                    </tr>
                                  )}
                                </React.Fragment>
                              );
                            })}

                            {/* Payment Summary */}
                            <tr style={{ backgroundColor: "#e9ecef" }}>
                              <td
                                colSpan="4"
                                style={{
                                  verticalAlign: "middle",
                                  padding: "10px 0",
                                  textAlign: "left",
                                  fontWeight: "bold",
                                }}
                              >
                                Total payé:
                              </td>

                              <td
                                align="center"
                                style={{
                                  verticalAlign: "middle",
                                  padding: "10px 0",
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  color: "#28a745",
                                }}
                              >
                                {payments
                                  .reduce(
                                    (acc, p) =>
                                      acc + (p.amount || 0) - (p.rendu || 0),
                                    0,
                                  )
                                  .toFixed(3)}
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                  )}
                </div>

                {/* Fixed Footer - Always visible */}
              </div>
            </div>

            {/* Payment Drawer */}
            <PaymentDrawer
              parametrages={parametrages}
              items={selectedItems.length ? selectedItems : items}
              drawerOpen={drawerOpen}
              toggleDrawer={toggleDrawer}
              cartTotal={cartTotal}
              totalSession={total}
              total={
                selectionMode && selectedItems.length > 0
                  ? selectedItems.reduce((acc, item) => acc + item.netPrice, 0)
                  : total // This is the original total prop passed to CaisseCart
              }
              previousPayments={previousPayments}
              tabIndex={tabIndex}
              handleTabChange={handleTabChange}
              cartItems={cartItems}
              orderItems={orderItems}
              selectedTable={selectedTable}
              handleClearTable={handleClearTable}
              selectedClient={selectedClient}
              onClientSelect={onClientSelect}
              organisation={organisation}
              occupiedTableData={occupiedTableData}
              onClearCart={onClearCart}
              setRefresh={setRefresh}
              refresh={refresh}
              resetClientToDefault={resetClientToDefault}
            />
          </div>
        </section>
        {/* /.content */}
      </div>
      <div
        className="row mt-auto border-top p-2"
        style={{
          height: "300px" /* Kept strict 300px height as requested */,
          position:
            "relative" /* Allows manual positioning relative to layout flow */,
          zIndex:
            "10" /* Ensures buttons render cleanly on top of any background layers */,
          marginTop:
            "-45px" /* Shifts the panel UP to grab space from the upper container-full */,
          backgroundColor:
            "#fff" /* Clean opaque backdrop so text from above doesn't bleed underneath */,
          overflow: "visible",
        }}
      >
        {/* Keypad Section */}
        <div
          style={{
            flex:
              !cartItems.length && !orderItems.length
                ? "0 0 100%"
                : "0 0 66.66%",
            maxWidth:
              !cartItems.length && !orderItems.length ? "100%" : "66.66%",
            transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)", // Smooth easing
            display: "flex",
            alignItems: "stretch",
            justifyContent: "center",
            borderRight:
              !cartItems.length && !orderItems.length
                ? "none"
                : "1px solid #dee2e6",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "stretch",
              padding: "0 5px",
            }}
          >
            {calculatorSlot}
          </div>
        </div>

        {/* Action Buttons Section */}
        <div
          style={{
            flex:
              !cartItems.length && !orderItems.length ? "0 0 0%" : "0 0 33.33%",
            maxWidth: !cartItems.length && !orderItems.length ? "0%" : "33.33%",
            opacity: !cartItems.length && !orderItems.length ? 0 : 1,
            transform:
              !cartItems.length && !orderItems.length
                ? "translateX(20px)"
                : "translateX(0)",
            transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
            overflow: "hidden", // Hides buttons as the column shrinks
            padding: !cartItems.length && !orderItems.length ? "0" : "15px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
          }}
        >
          {focusedItemId ? (
            // While the focused item editor (price/remise/quantity) is open,
            // this slot becomes a single confirm button — same effect as the
            // back arrow (commits the edit and asks whether it should stick
            // to the catalog product or stay a one-off override).
            <div className="d-flex flex-column gap-2" style={{ flex: 1 }}>
              <button
                className="btn btn-lg btn-success shadow-sm"
                onClick={closeFocusedItem}
                style={{
                  height: "60px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                }}
              >
                <i className="fa fa-check mr-2"></i> CONFIRMER
              </button>
            </div>
          ) : (
            <>
              {orderItems.length && !cartItems.length ? (
                <div className="p-2 mb-2 border rounded bg-white shadow-sm">
                  <Form.Check
                    type="switch"
                    id="selection-mode-switch"
                    label={<strong>Mode Sélection</strong>}
                    checked={selectionMode}
                    onChange={(e) => {
                      setSelectionMode(e.target.checked);
                      if (!e.target.checked) setSelectedItems([]);
                    }}
                  />
                </div>
              ) : null}

              {/* Main Action Buttons Stack */}
              <div className="d-flex flex-column gap-2" style={{ flex: 1 }}>
                {occupiedTableData?.session?.status === "active" && (
                  <>
                    <button
                      className="btn btn-lg btn-secondary shadow-sm mb-2"
                      onClick={handleAddictionPrint}
                      style={{
                        height: "60px",
                        fontSize: "1.1rem",
                        fontWeight: "600",
                      }}
                    >
                      <i className="fas fa-clipboard-list mr-2"></i> ADDITION
                    </button>

                    {!cartItems.length &&
                      (infoUser.role === "caissier" ||
                        infoUser.role === "admin") && (
                      <button
                        className="btn btn-lg btn-success shadow-sm mb-2"
                        onClick={toggleDrawer(true)}
                        style={{
                          height: "60px",
                          fontSize: "1.1rem",
                          fontWeight: "600",
                        }}
                      >
                        <i className="fa fa-credit-card mr-2"></i> PAIEMENT
                      </button>
                    )}
                  </>
                )}

                {cartItems.length > 0 && (
                  <>
                    {!selectedTable.default && (
                      <button
                        className="btn btn-lg btn-primary shadow-sm mb-2"
                        onClick={handleValidateCart}
                        style={{
                          height: "60px",
                          fontSize: "1.1rem",
                          fontWeight: "600",
                        }}
                      >
                        {/* <i className="fa fa-check mr-2"></i>  */}
                        VALIDER
                      </button>
                    )}
                    {(infoUser.role === "caissier" ||
                      infoUser.role === "admin") && (
                      <button
                        className="btn btn-lg btn-success shadow-sm"
                        onClick={toggleDrawer(true)}
                        style={{
                          height: "60px",
                          fontSize: "1.1rem",
                          fontWeight: "600",
                        }}
                      >
                        {/* <i className="fa fa-money-bill-wave mr-2"></i> */}
                        PAIEMENT
                      </button>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>

      <OrderDetailsModal
        open={receiptModalOpen}
        onClose={() => setReceiptModalOpen(false)}
        cart={receiptCart}
        currency="TND"
      />
    </div>
  );
};

export default CaisseCart;
